import axios from "axios";
import { API_BASE_URL as API } from "../../apiConfig";

export function reportBookingFailure(stage, error) {
  // Best effort only: diagnostics must never block the booking form.
  axios.post(`${API}/booking-client-errors`, {
    stage,
    status: error.response?.status || 0,
    network_error: !error.response,
  }, { timeout: 3000 }).catch(() => {});
}

// Only configuration reads and the side-effect-free price calculation may retry.
export async function bookingRead(url, data) {
  for (let attempt = 0; ; attempt += 1) {
    try {
      return data === undefined
        ? await axios.get(url, { timeout: 15000 })
        : await axios.post(url, data, { timeout: 15000 });
    } catch (error) {
      const transient = [502, 503, 504].includes(error.response?.status)
        || (!error.response && ["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT"].includes(error.code));
      if (!transient || attempt >= 2) throw error;
      await new Promise(resolve => setTimeout(resolve, 750 * (attempt + 1)));
    }
  }
}

export const bookingMessages = {
  zh: { retry: "重试", config: "预约选项加载失败，已填内容保留，请重试。", network: "网络暂时不可用，已填内容保留，请重试。", uncertain: "尚未确认提交结果。请勿重新填写同一订单，先检查订单列表；重试会沿用本次请求编号。", auth: "登录已失效，请在另一个标签页重新登录后回到这里重试，已填内容保留。", failed: "请求失败，请检查填写内容后重试。" },
  ja: { retry: "再試行", config: "予約項目を読み込めませんでした。入力内容は保持されています。", network: "通信できません。入力内容を保持しています。再試行してください。", uncertain: "送信結果を確認できません。同じ予約を新規入力せず、予約一覧をご確認ください。再試行は同じリクエスト番号を使用します。", auth: "ログインの有効期限が切れました。別タブでログインし直してから再試行してください。入力内容は保持されています。", failed: "処理できませんでした。入力内容をご確認ください。" },
  en: { retry: "Retry", config: "Booking options could not load. Your entries are preserved. Please retry.", network: "Connection unavailable. Your entries are preserved. Please retry.", uncertain: "Submission result is unconfirmed. Check your orders before starting a new booking. Retrying uses the same request ID.", auth: "Your session has expired. Sign in in another tab, then return here and retry. Your entries are preserved.", failed: "Request failed. Check the details and retry." },
  es: { retry: "Reintentar", config: "No se pudieron cargar las opciones. Sus datos se conservan. Reintente.", network: "Sin conexión. Sus datos se conservan. Reintente.", uncertain: "El resultado del envío no está confirmado. Revise sus reservas antes de crear otra. Reintentar utiliza el mismo identificador.", auth: "La sesión ha caducado. Inicie sesión en otra pestaña y vuelva a intentarlo. Sus datos se conservan.", failed: "No se pudo completar la solicitud. Revise los datos." },
};

export function bookingErrorMessage(error, language, submitting = false) {
  const copy = bookingMessages[language] || bookingMessages.en;
  if (error.response?.status === 401) return copy.auth;
  if (!error.response || error.response.status >= 500) return submitting ? copy.uncertain : copy.network;
  const detail = error.response.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(item => `${(item.loc || []).filter(part => part !== "body").join(".")}: ${item.msg}`).join("; ");
  return detail?.[`message_${language}`] || detail?.message || copy.failed;
}
